import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import VisibilityIcon from "@mui/icons-material/Visibility";

const DocumentList = ({ documents }) => {
  return (
    <Grid container spacing={3}>
      {documents?.map((doc, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Card
            variant="outlined"
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
              borderRadius: "10px",
            }}
          >
            <InsertDriveFileIcon
              sx={{ fontSize: 40, mr: 2, color: "#006CB8" }}
            />
            <Box flexGrow={1}>
              <Typography
                variant="subtitle1"
                sx={{ fontFamily: "Geist, sans-serif", fontWeight: "500" }}
              >
                {doc?.CDS_CheckListName}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ fontFamily: "Geist, sans-serif" }}
              >
                {doc?.CDS_DocumentName}
              </Typography>

              <Typography
                variant="subtitle1"
                sx={{ fontFamily: "Geist, sans-serif" }}
              >
                {doc?.CDS_Comment}
              </Typography>
              {/* <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontFamily: "Geist, sans-serif" }}
              >
                {doc?.CDS_DocumentPath.split("/").pop()}
              </Typography> */}
            </Box>
            <VisibilityIcon
              onClick={() => {
                if (!doc?.CDS_DocumentPath) return;

                window.open(
                  `${process.env.REACT_APP_BASE_URL}/${doc.CDS_DocumentPath}`,
                  "_blank"
                );
              }}
              sx={{
                color: doc?.CDS_DocumentPath ? "#006CB8" : "#B0B0B0",
                cursor: doc?.CDS_DocumentPath ? "pointer" : "not-allowed",
              }}
            />

          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default DocumentList;
